import React__default, { useState, useRef, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { H as Heading } from '../../Heading/Heading-_71dBU2D.js';
import { T as Tooltip } from '../../Tooltip/Tooltip-BppPzdQy.js';
import { I as IconButton } from '../../Button/IconButton/IconButton-B-_fri-k.js';
import { T as Text } from '../../Text/Text-CO4HftGt.js';

const SummaryCardHeaderContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40026394__sc-1xc53dq-0"
})(["display:flex;align-items:start;align-self:stretch;justify-content:space-between;min-height:", ";margin-block-end:", ";"], ({
  theme
}) => theme.controls.height.base.default, ({
  theme
}) => theme.summaryCard.gap);
SummaryCardHeaderContainer.displayName = 'SummaryCardHeaderContainer';
const SummaryCardTitleContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40026394__sc-1xc53dq-1"
})(["display:flex;align-items:flex-end;gap:", ";align-items:center;"], ({
  theme
}) => theme.spacing.xxsmall.default);
SummaryCardTitleContainer.displayName = 'SummaryCardTitleContainer';
const StyledText = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-storm-ui-40026394__sc-1xc53dq-2"
})(["padding-block-end:", ";"], ({
  theme
}) => theme.summaryCard.header.content.paddingBlockEnd);
StyledText.displayName = 'StyledText';
const AdditionalContentWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40026394__sc-1xc53dq-3"
})([""]);
const SummaryCardHeader = ({
  title,
  level = 'h4',
  additionalContent,
  toggleButtonLabel,
  toggleButtonTooltip,
  isExpandable = false,
  isExpanded = false,
  onToggleButtonClick,
  toggleIcon
}) => {
  const [hideTooltip, setHideTooltip] = useState(true);
  const toggleButtonRef = useRef(null);
  useEffect(() => {
    if (isExpanded) {
      var _toggleButtonRef$curr;
      toggleButtonRef === null || toggleButtonRef === void 0 || (_toggleButtonRef$curr = toggleButtonRef.current) === null || _toggleButtonRef$curr === void 0 || _toggleButtonRef$curr.focus();
    }
  }, [isExpanded, toggleButtonRef]);
  const getToggleButton = useCallback(() => {
    const handleButtonToggle = event => {
      setHideTooltip(true);
      onToggleButtonClick === null || onToggleButtonClick === void 0 || onToggleButtonClick(event);
    };
    const onMouseOver = () => {
      if (hideTooltip) {
        setHideTooltip(false);
      }
    };
    const ToggleButton = /*#__PURE__*/React__default.createElement(IconButton, {
      taktId: `toggle-button-${isExpanded ? 'close' : 'open'}`,
      "data-testid": `toggle-button-${isExpanded ? 'close' : 'open'}`,
      icon: toggleIcon,
      label: toggleButtonLabel,
      onClick: handleButtonToggle,
      variant: "transparent",
      onMouseEnter: onMouseOver,
      "aria-haspopup": !isExpanded && 'dialog',
      buttonRef: toggleButtonRef
    });
    return hideTooltip ? ToggleButton : /*#__PURE__*/React__default.createElement(Tooltip, {
      nonInteractive: true,
      position: "top",
      message: toggleButtonTooltip,
      variant: "inverted",
      trigger: ToggleButton
    });
  }, [hideTooltip, isExpanded, onToggleButtonClick, toggleButtonLabel, toggleButtonTooltip, toggleIcon, toggleButtonRef]);
  return /*#__PURE__*/React__default.createElement(SummaryCardHeaderContainer, null, /*#__PURE__*/React__default.createElement(SummaryCardTitleContainer, null, /*#__PURE__*/React__default.createElement(Heading, {
    renderAs: level
  }, title), typeof additionalContent === 'string' && /*#__PURE__*/React__default.createElement(StyledText, {
    size: "small",
    color: "secondary"
  }, additionalContent), typeof additionalContent !== 'string' && /*#__PURE__*/React__default.createElement(AdditionalContentWrapper, null, additionalContent)), isExpandable && getToggleButton());
};
SummaryCardHeader.displayName = 'SummaryCardHeader';

export { SummaryCardHeader as S };
//# sourceMappingURL=SummaryCardHeader-CIhvLtFw.js.map
